const config = {
    apiUrl: 'https://digital.allcasino.in:3000/',
    // apiUrl: 'http://127.0.0.1:3000/',
    bUrl: 'http://139.162.213.154:3000/',
    userTypes: ['Admin', 'Super Admin', 'Sub Admin', 'Super Master', 'Sub Master', 'Master', 'User'],
    userTypesAlias: {
        'admin': 'Admin', 'super_admin': 'Super Admin', 'sub_admin': 'Sub Admin', 'super_master': 'Super Master', 'sub_master': 'Sub Master', 'master': 'Master', 'user': 'User'
    },
    superAdmin: '65f992a367adaa45d6e937d0',
    sitecodes: 'P43',
    DEFAULT_CURRENCY: 'PBU',

    // videoUrl: {
    //     '7ud': 'https://route53.casinovid.in/dvideo/lucky7a/',
    //     'ab': 'https://route53.casinovid.in/dvideo/andarbahar/',
    //     'ltp': 'https://route53.casinovid.in/dvideo/onedaytp/',
    //     't20': 'https://route53.casinovid.in/dvideo/teen20',
    //     'dt20': 'https://route53.casinovid.in/dvideo/dragontiger20/',
    //     'aaa': 'https://route53.casinovid.in/dvideo/amar',
    //     '32c': 'https://route53.casinovid.in/dvideo/32b/',
    // }
    videoUrl: {
        '7ud': 'https://tv.fireflybet.in/index.html?id=3058',
        'ab': 'https://route53.casinovid.in/dvideo/andarbahar/',
        'ltp': 'https://backlayexchange.com/new/oneday/',
        't20': 'https://backlayexchange.com/new/2020/',
        'dt20': 'https://tv.fireflybet.in/index.html?id=3059/',
        'aaa': 'https://shroute.casinovid.in/diamondvideo/dot.php?id=3056',
        '32c': 'https://shroute.casinovid.in/diamondvideo/dot.php?id=3034',
    }
    // videoUrl: {
    //     '7ud': 'http://45.56.112.18/?id=3081',
    //     'ab': 'http://45.56.112.18/?id=3082',
    //     'ltp': 'http://45.56.112.18/?id=3080',
    //     't20': 'http://45.56.112.18/?id=3085',
    //     'dt20': 'http://45.56.112.18/?id=3087',
    //     'aaa': 'http://45.56.112.18/?id=3086',
    //     '32c': 'http://45.56.112.18/?id=3084',
    // }
    // http://139.162.213.154/dvideo/teen20.html
    ,
    marketSarket: "http://marketsarket.in:3002/",
    casino_type_id: {
        '7ud': '1001',
        'ab': '1002',
        'ltp': '1003',
        't20': '1004',
        'dt20': '1005',
        'aaa': '1006',
        '32c': '1007'
    },
    casino_event_id: {
        '7ud': '98789',
        'ab': '87564',
        'ltp': '56767',
        't20': '56768',
        'dt20': '98790',
        'aaa': '98791',
        '32c': '56967'
    },
    WCOCasino: [
        {
            title: "EVO",
            provider_code: "EVZ",
            game_code: "1000000",
            type: 'EV',
            src: 'banner_evo-half.webp',
        },
        {
            title: "Ezugi",
            provider_code: "EZ",
            game_code: "",
            type: '',
            src: 'banner_ezugi-half.webp',
        },
        {
            title: "Royal Gaming",
            provider_code: "DC",
            game_code: "900000",
            type: '',
            src: 'banner_royalgaming.webp',
        },
        // {
        //     title: "Sky Casino",
        //     provider_code: "WCO lobby",
        //     game_code: "WCO lobby",
        //     type: '',
        //     src: 'banner_skycasino-half.webp',
        // },
        // {
        //     title: "Live Casino",
        //     provider_code: "PP",
        //     game_code: "1302",
        //     type: '',
        //     src: 'banner_casino-half.webp',
        // },
        {
            title: "Spribe",
            provider_code: "SPB",
            game_code: "aviator",
            type: '',
            src: 'banner_spribe.webp',
        },
        {
            title: "Blackjack",
            provider_code: "DC",
            game_code: "400077",
            type: '',
            src: 'banner_blackjack-half.webp',
        },
        {
            title: "7 Up Down",
            provider_code: "DC",
            game_code: "900001",
            type: '',
            src: 'banner_7up7down-half.webp',
        },
        {
            title: "Andar Bahar VR",
            provider_code: "DC",
            game_code: "901021",
            type: '',
            src: 'banner_andarBaharVR-half.png',
        },
        {
            title: "Supernowa",
            provider_code: "SN",
            game_code: "",
            type: '',
            src: 'banner_supernowa-half.webp',
        },
        {
            title: "HORSEBOOK",
            provider_code: "DC",
            game_code: "400086",
            type: '',
            src: 'banner_horsebook-half.webp',
        },
        {
            title: "Minesweeper",
            provider_code: "DC",
            game_code: "400080",
            type: '',
            src: 'banner_minesweeper-half.webp',
        },
        {
            title: "Teen Patti",
            provider_code: "DC",
            game_code: "900019",
            type: '',
            src: 'banner_teenPatti-half.webp',
        },
        {
            title: "Super Over VR",
            provider_code: "DC",
            game_code: "901034",
            type: '',
            src: 'banner_superOverVR-half.webp',
        },
        {
            title: "TeenPatti 20-20",
            provider_code: "DC",
            game_code: "600112",
            type: '',
            src: 'banner_TeenPatti2020-half.webp',
        },
        {
            title: "NumberKing",
            provider_code: "DC",
            game_code: "600015",
            type: '',
            src: 'banner_NumberKing-half.webp',
        },
        {
            title: "Big small",
            provider_code: "DC",
            game_code: "600086",
            type: '',
            src: 'banner_BigSmall-half.webp',
        },
        {
            title: "TeenPatti Joker",
            provider_code: "DC",
            game_code: "600110",
            type: '',
            src: 'banner_TeenPattiJoker-half.webp',
        },
        {
            title: "7up7down",
            provider_code: "DC",
            game_code: "600064",
            type: '',
            src: 'banner_7up7down-half-1.webp',
        },
        {
            title: "Dragon & Tiger",
            provider_code: "DC",
            game_code: "600087",
            type: '',
            src: 'banner_DragonNTiger-half.webp',
        },
        {
            title: "Auto Roulette",
            provider_code: "DC",
            game_code: "900002",
            type: '',
            src: 'banner_autoRoulette-half.webp',
        },
        {
            title: "Dus Ka Dum (Cards) VR",
            provider_code: "DC",
            game_code: "901013",
            type: '',
            src: 'banner_DusKaDumVR-half.webp',
        },
        {
            title: "Callbreak Quick",
            provider_code: "DC",
            game_code: "600109",
            type: '',
            src: 'banner_CallbreakQuick-half.webp',
        },
        {
            title: "Sic Bo",
            provider_code: "DC",
            game_code: "600065",
            type: '',
            src: 'banner_SicBo-Jili-half.webp',
        },
        {
            title: "Baccarat",
            provider_code: "DC",
            game_code: "600089",
            type: '',
            src: 'banner_Baccarat-half.webp',
        },
        {
            title: "Bonus Dice",
            provider_code: "DC",
            game_code: "400081",
            type: '',
            src: 'banner_BonusDice-half.webp',
        },
        {
            title: "Heist",
            provider_code: "DC",
            game_code: "400085",
            type: '',
            src: 'banner_Heist-half.webp',
        },
        {
            title: "5 Card Poker",
            provider_code: "DC",
            game_code: "400087",
            type: '',
            src: 'banner_5CardPoker-half.webp',
        },
        {
            title: "Color Game",
            provider_code: "DC",
            game_code: "400088",
            type: '',
            src: 'banner_ColorGame-half.webp',
        },
        {
            title: "32 Cards",
            provider_code: "DC",
            game_code: "400078",
            type: '',
            src: 'banner_32card-half.webp',
        },
        {
            title: "Rummy",
            provider_code: "DC",
            game_code: "600014",
            type: '',
            src: 'banner_rummy-half.webp',
        },
        {
            title: "Dragon Tiger",
            provider_code: "DC",
            game_code: "900004",
            type: '',
            src: 'banner_DragonTiger-half.webp',
        },
        {
            title: "Worli Matka VR",
            provider_code: "DC",
            game_code: "901010",
            type: '',
            src: 'banner_worliMatkaVR-half.webp',
        },
        {
            title: "BetGames",
            provider_code: "QT",
            game_code: "BTV-baccarat",
            type: '',
            src: 'banner_betgames-half.webp',
        },
        {
            title: "Andar Bahar",
            provider_code: "DC",
            game_code: "400071",
            type: '',
            src: 'banner_andarBahar-half.webp',
        },
        {
            title: "Sicbo",
            provider_code: "DC",
            game_code: "400056",
            type: '',
            src: 'banner_sicbo-half.webp',
        },
        {
            title: "7 UP 7 Down",
            provider_code: "DC",
            game_code: "400067",
            type: '',
            src: 'banner_sevenUpDown-half.webp',
        },
        {
            title: "Coin Toss",
            provider_code: "DC",
            game_code: "400075",
            type: '',
            src: 'banner_CoinToss-half.webp',
        },
        {
            title: "Teen Patti",
            provider_code: "DC",
            game_code: "600011",
            type: '',
            src: 'banner_teenPatti-half-1.webp',
        },
        {
            title: "Card Matka",
            provider_code: "DC",
            game_code: "400062",
            type: '',
            src: 'banner_cardMatka-half.webp',
        },
        {
            title: "Number Matka",
            provider_code: "DC",
            game_code: "400061",
            type: '',
            src: 'banner_numberMatka-half.webp',
        },
    ]

}


// Define site codes and superAdmin for different domains
const domainConfig = {
    'skyexch99.art': { sitecodes: 'P23', superAdmin: '65f992a367adaa45d6e937d0', DEFAULT_CURRENCY: 'PBU' },
    'betbuzz24.live': { sitecodes: 'P23', superAdmin: '67e4034532961547e8a94d77', DEFAULT_CURRENCY: 'PBU' },
    'skyexch.sbs': { sitecodes: 'P43', superAdmin: '67f77d8287c99d72311be959', DEFAULT_CURRENCY: 'PTH' },
};

// Get the current hostname
const currentDomain = window.location.hostname;

// Assign the site code and superAdmin dynamically based on the domain
if (domainConfig[currentDomain]) {
    config.sitecodes = domainConfig[currentDomain].sitecodes;
    config.superAdmin = domainConfig[currentDomain].superAdmin;
    config.DEFAULT_CURRENCY = domainConfig[currentDomain].DEFAULT_CURRENCY;
}

export default config;

// export const SOCKET_URL = 'https://digitalws.lce247.com:8040/';
export const SOCKET_URL = 'wss://ws.operator.buzz:7072/';
// export const SOCKET_URL = 'wss://ws.maza247.vip:7071/';


// export const DEFAULT_CURRENCY = 'PBU';

